export default __webpack_public_path__ + "static/media/Dog_cat.79b22ceb.png";